<template>
  <HeadlessTransitionRoot as="template" :show="isOpen">
    <HeadlessDialog
      as="div"
      class="relative z-10"
      @close="handleDialogOutsideClick"
    >
      <HeadlessTransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-background-fg/30 transition-opacity"
        />
      </HeadlessTransitionChild>

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div
          class="flex h-full min-h-0 items-center justify-center p-4 text-center"
        >
          <HeadlessTransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <HeadlessDialogPanel
              class="relative flex max-h-full min-h-0 flex-col overflow-hidden rounded-lg bg-background p-4 text-left shadow-xl transition-all sm:w-full sm:max-w-lg sm:p-6"
            >
              <slot />
            </HeadlessDialogPanel>
          </HeadlessTransitionChild>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
const props = defineProps<{
  isOpen: boolean
  disableClickOutside?: boolean
}>()

const emit = defineEmits<{
  (event: "close"): void
}>()

const handleDialogOutsideClick = () => {
  if (props.disableClickOutside) return

  emit("close")
}
</script>
